import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Container from "react-bootstrap/Container";
import Form from "react-bootstrap/Form";
import Layout from "../Components/Layout/Layout";
import * as Yup from "yup";
import {
  Formik,
  Field,
  ErrorMessage,
  Form as FormikForm,
  FieldArray,
} from "formik";
import { Button, Col, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { addSource, getSource } from "../Redux/Actions/event";
import { startstopLoading } from "../Redux/Reducers/globalSlice";

const validationSchema = Yup.object({
  // domains: Yup.array()
  //   .of(
  //     Yup.string()
  //       .url("Invalid URL")
  //       .required("Additional link is required")
  //   )
  //   .min(1, "At least one additional link is required"),
  prompt: Yup.string()
    .trim()
    .required("prompt is required")
    .min(20, "prompt must be at least 20 characters"),
});

export default function Source() {

  const sourceDetails = useSelector((e) => e.botAuth.sourceDetails)

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [loading, setLoading] = useState(false);

  const initialValues = {
    // domains: sourceDetails?.domains ? sourceDetails?.domains : [""],
    prompt: sourceDetails?.prompt ? sourceDetails?.prompt : "",
  };

  const handleSubmit = async (values) => {
    try {
      await dispatch(addSource(values)).then((res) => {
        if (res.payload.status == 201 || res.payload.status === 200) {
          // toast.success(res?.payload?.message);
          // navigate("/prompts");
        } else {
          setLoading(false);
        }
      });
    } catch (error) {
      setLoading(false);
    }
  };

  useEffect(() => {
    dispatch(startstopLoading(true));
    dispatch(getSource()).then(() => {
      dispatch(startstopLoading(false));
    });
  }, [dispatch]);


  return (
    <Layout>
      <Container fluid>
        <div className="filters pb-2">
          <div className="inner-filter-field">
            <div className="image-heading-text">
              <h2>Manage Resource</h2>
            </div>
          </div>
          <div className=" new-tabs-add">
            <Formik
              initialValues={initialValues}
              validationSchema={validationSchema}
              onSubmit={handleSubmit}
              enableReinitialize={true}
            >
              {({
                values,
                setFieldValue,
                setFieldTouched,
                setFieldError,
                handleSubmit,
                errors,
                touched,
              }) => (
                <FormikForm onSubmit={handleSubmit}>
                  <div className="create-notification-page new-tabs-add">
                    <div className="general-heading">
                      <h2>General</h2>
                    </div>

                    <div className="category-field">
                      <div className="general-box">
                        <Row>
                          <Col lg={12}>
                            <div className="modal-input mt-3">
                              <label>Prompt</label>
                              <Form.Group>
                                <Field
                                  name="prompt"
                                  type="text"
                                  className="form-control"
                                  as="textarea"
                                  rows={8}
                                  placeholder="Enter here"
                                />
                                <ErrorMessage
                                  name="prompt"
                                  component="div"
                                  className="text-danger"
                                />
                              </Form.Group>
                            </div>
                          </Col>
                          {/* <Col lg={12}>
                            <div className="modal-input mt-3">
                              <FieldArray name="domains">
                                {({ push, remove, form }) => (
                                  <div className="modal-input mt-3">
                                    <Form.Group className="mb-3 ">
                                      <Form.Label>Resource Link</Form.Label>
                                      {form?.values?.domains?.map(
                                        (link, index) => (
                                          <>
                                            <div
                                              key={index}
                                              className="d-flex align-items-center gap-2 mb-2"
                                            >
                                              <Field
                                                name={`domains[${index}]`}
                                                type="text"
                                                className="form-control"
                                                placeholder="Enter link"
                                              />
                                              {index > 0 && (
                                                <Button
                                                  type="button"
                                                  variant="danger"
                                                  className="ms-2"
                                                  onClick={() => remove(index)}
                                                >
                                                  -
                                                </Button>
                                              )}
                                              <Button
                                                type="button"
                                                variant="primary"
                                                onClick={() => push("")}
                                              >
                                                +
                                              </Button>
                                            </div>
                                            <ErrorMessage
                                              name={`domains[${index}]`}
                                              component="div"
                                              className="text-danger"
                                            />
                                          </>
                                        )
                                      )}
                                    </Form.Group>
                                  </div>
                                )}
                              </FieldArray>
                            </div>
                          </Col> */}
                        </Row>
                      </div>
                      <div className="create-btn">
                        <button type="submit">Save</button>
                      </div>
                    </div>
                  </div>
                </FormikForm>
              )}
            </Formik>
          </div>
        </div>
        <div className="made-with">
          <div className="pixinvent">
            <p>
              © {new Date().getFullYear()}, Made with ❤️ by{" "}
              <span> Codobux</span>
            </p>
          </div>
        </div>
      </Container>
    </Layout>
  );
}
